import { isNone } from '@ember/utils';
import EventCondition from 'cio/app-models/conditions/event';
import refinement from './refinement';
import { deserializeFilter as deserializeAttribute } from 'cio/utils/conditions/deserialize/attribute';
import deserializeAttributeCompare from 'cio/utils/conditions/deserialize/attribute-compare';
import { any, all } from 'cio/app-models/conditions/group';
import { SerializedEventCondition } from 'cio/types/conditions/condition';
import { SerializedLegacyAttributeFilter, SerializedLegacyAttributeFilters } from 'cio/types/conditions/legacy-filter';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import { isGroupAndCondition, isGroupOrCondition, isSimpleCondition } from 'cio/utils/conditions/deserialize';

function filterToAttribute(filter: SerializedLegacyAttributeFilter, event: string) {
  if (filter.type === 'attribute_compare') {
    return deserializeAttributeCompare({ ...filter, event });
  }

  return deserializeAttribute({ ...filter, event, type: 'event_attribute' }) as EventAttributeCondition;
}

export function deserializeFilters(
  tree: SerializedLegacyAttributeFilters | Record<string, never>,
  event: string,
): EventAttributeCondition[] {
  if (isNone(tree) || Object.keys(tree).length === 0) {
    return [];
  }

  if (isSimpleCondition(tree)) {
    return [filterToAttribute(tree, event) as EventAttributeCondition];
  }

  let group: SerializedLegacyAttributeFilters[] | null = null;
  if (isGroupAndCondition(tree)) {
    group = tree.and;
  } else if (isGroupOrCondition(tree)) {
    group = tree.or;
  }
  if (group) {
    return group.map((f: SerializedLegacyAttributeFilter) => filterToAttribute(f, event) as EventAttributeCondition);
  }

  return [];
}

export function filterOperator(filters: SerializedLegacyAttributeFilters | Record<string, never> | null) {
  if (isNone(filters)) {
    return all;
  }

  if (isGroupOrCondition(filters)) {
    return any;
  } else {
    return all;
  }
}

export default function (json: SerializedEventCondition) {
  let { event } = json;
  let { times, within, inverse } = json;

  if (isNone(times) && isNone(within)) {
    times = 1;
    within = 0;
  }

  let filters = deserializeFilters(event?.filters, event.name);
  let isForeignEvent = (json as any).type === 'foreign_event';

  if (isForeignEvent) {
    filters.forEach((filter) => filter.set('isForeignEventFilterAttribute', true));
  }

  return EventCondition.create({
    name: event.name,
    inverse,
    refinement: refinement(times, within),
    filters,
    filterOperator: filterOperator(event?.filters),
    isForeignEvent,
  });
}
